import { http } from 'vue'

export default {
  // load rents from the API server
  loadInvoices (context, params = {}) {
    let pageParam = '&page=' + ((params.page) ? params.page : 1)
    let perPageParam = '&per_page=' + ((params.perPage) ? params.perPage : 50)
    let statusParam = (params.status) ? '&status=' + params.status : ''
    let conditionParam = (params.condition) ? '&condition=' + params.condition : ''
    let typeParam = (params.type) ? '&type=' + params.type : ''
    let periodParam = (params.period) ? '&period=' + params.period : ''
    let searchParam = (params.search) ? '&search=' + params.search : ''
    return http.get('invoices?company_id=' + params.companyId + pageParam + perPageParam + statusParam + conditionParam + typeParam + periodParam + searchParam)
  },
  loadFinancesDashboard (context, params = {}) {
    return http.get('dashboard/finances?company_id=' + params.companyId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices/actions.js